import styled from 'react-emotion'
import Nav from './Nav'
import NavItem from './NavItem'
import PageContainer from './PageContainer'
import { color } from 'stylist'

const Sidebar = styled.div`
  border-right: 1px solid ${color('paleGrey')};
  grid-row: 1 / -1;
`

Sidebar.Nav = Nav
Sidebar.NavItem = NavItem
Sidebar.PageContainer = PageContainer

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js